<template>
  <div class="detail_main"
       id="detailDiv">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>
            <router-link :to="'/indexNew'">数据总览</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>场库数据</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <div class="row_msg_tip"><span class="parkTitle"> 客户 </span>
      <el-select v-model="selfCustID"
                 filterable
                 placeholder="请选择客户"
                 style="width:200px;"
                 @change="loadPark($event,'1')">
        <el-option v-for="item in cust_list"
                   :key="item.fCustID"
                   :label="item.unionName"
                   :value="item.fCustID">
        </el-option>
      </el-select>
      &nbsp;&nbsp;场库&nbsp;&nbsp;
      <el-select v-model="selParkID"
                 filterable
                 @change="parkChange"
                 placeholder="请选择场库"
                 style="width:200px;"
                 clearable>
        <el-option v-for="item in park_list"
                   :key="item.fParkID"
                   :label="item.fParkName"
                   :value="item.fParkID">
        </el-option>
      </el-select>
    </div>
    <div class="outside">
      <div class="outsideTitle"><span class="outsideSpan">今日收入</span></div>
      <div class="outsideTitle2"><span class="outsideSpan">今日流量</span></div>
      <div class="outsideTitle2"><span class="outsideSpan">今日饱和度</span></div>
      <div class="outsideTitle3">
        <div class="insideTitle">应收金额</div>
        <div class="insideTitle">优惠金额</div>
        <div class="insideTitle">实收金额</div>
        <div class="insideTitle">优惠笔数</div>
        <div class="insideTitle">支付笔数</div>
        <div class="insideValueVerLine">&nbsp;</div>
        <div class="insideTitle">入场车辆</div>
        <div class="insideTitle">离场车辆</div>
        <div class="insideValueVerLine">&nbsp;</div>
        <div class="insideLastTitle">饱和度</div>
        <div class="insideLastTitle">场内车辆</div>
        <div class="insideBothClear"></div>
        <div class="insideValue">{{fCalcAmt}}</div>
        <div class="insideValue">{{fDedAmt}}</div>
        <div class="insideValue">{{fPayAmount}}</div>
        <div class="insideValue">{{fCouPayCnt}}</div>
        <div class="insideValue">{{fPayCnt}}</div>
        <div class="insideValueVerLine">&nbsp;</div>
        <div class="insideValue">{{fInParkCnt}}</div>
        <div class="insideValue">{{fOutParkCnt}}</div>
        <div class="insideValueVerLine">&nbsp;</div>
        <div class="insideValueLast">{{fParkRate}}</div>
        <div class="insideValueLast">{{fParkCount}}</div>
        <div class="insideBothClear"></div>
      </div>
    </div>
    <div class="row_table">
      <div class="row">
        <div class="icon_theme_one"
             v-bind:class="{icon_theme_active:!isOld}"
             @click="hadnleSwitch(false)">今日收入</div>
        <div class="icon_theme_two"
             v-bind:class="{icon_theme_active:isOld}"
             @click="hadnleSwitch(true)">今日流量</div>
      </div>
      <div style="display: none"
           class="row "
           id="todayMoney">
        <el-col :span="14"
                class="col_backcolor">
          <el-table :data="parkPayList"
                    :height="300"
                    style="padding-left:20px;width: 100%">
            <el-table-column prop="fOuterName"
                             label="支付方式"
                             width="180">
            </el-table-column>
            <el-table-column prop="fPayAmount"
                             align="right"
                             label="收入金额（元）">
            </el-table-column>
            <el-table-column prop="fPayAmountRate"
                             align="right"
                             label="支付占比">
            </el-table-column>
            <el-table-column prop="fPayCnt"
                             align="right"
                             label="支付笔数">
            </el-table-column>
            <el-table-column prop="fPayCntRate"
                             align="right"
                             label="比数占比">
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="10"
                class="col_backcolor">
          <div id="payChart"
               style="with:100%; height:300px;padding-left:20px; "></div>
        </el-col>
      </div>
      <div style="display: none"
           class="row "
           id="todayFlow">
        <el-col :span="8"
                class="col_backcolorBlank">
          <div style="background-color: #F7F6FC">
            <el-row>
              <el-col :span="8"
                      style="padding:10px;">今日流量</el-col>
              <el-col :span="8"
                      style="padding:10px;">入场车辆:<span style="color:#5f95e4">{{this.fInParkCnt}}</span></el-col>
              <el-col :span="8"
                      style="padding:10px;">离场车辆:<span style="color:#e7404a">{{this.fOutParkCnt}}</span></el-col>
            </el-row>
            <div id="flowChart"
                 style="width:100%;height:244px;">
            </div>
          </div>
        </el-col>
        <el-col :span="8"
                class="col_backcolorBlank">
          <div id="inParkChart"
               style="with:100%; height:280px;background-color: #F7F6FC"></div>
        </el-col>
        <el-col :span="8"
                class="col_backcolorBlank">
          <div id="outParkChart"
               style="width:100%;height:280px;background-color: #F7F6FC"></div>
        </el-col>
      </div>
    </div>
    <div style="clear: both"></div>
    <div class="row_table">
      <div class="row">
        <div class="icon_theme_one"
             style="background: #f4f2fc">收入趋势（较昨日同时刻）</div>
      </div>
      <table v-if="!isOld"
             class="table_view">
        <thead>
          <tr>
            <td style="background: #f4f2fc"></td>
            <td>微信支付</td>
            <td>支付宝支付</td>
            <td>银联支付</td>
            <td>现金支付</td>
            <td>其他支付</td>
            <td>优惠券</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>支付金额</td>
            <td>{{tAdnYMoney.weChatPayRate}} <span :class="tAdnYMoney.weChatPayRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.weChatPayRateStr}}</span></td>
            <td>{{tAdnYMoney.aliPayRate}} <span :class="tAdnYMoney.aliPayRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.aliPayRateStr}}</span> </td>
            <td>{{tAdnYMoney.unPayRate}} <span :class="tAdnYMoney.unPayRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.unPayRateStr}}</span> </td>
            <td>{{tAdnYMoney.cashPayRate}} <span :class="tAdnYMoney.cashPayRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.cashPayRateStr}}</span> </td>
            <td>{{tAdnYMoney.otherPaytRate}} <span :class="tAdnYMoney.otherPaytRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.otherPaytRateStr}}</span> </td>
            <td>{{tAdnYMoney.couPayRate}} <span :class="tAdnYMoney.couPayRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.couPayRateStr}}</span> </td>
          </tr>
          <tr>
            <td>支付笔数</td>
            <td>{{tAdnYMoney.weChatPayCntRate}} <span :class="tAdnYMoney.weChatPayCntRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.weChatPayCntRateStr}}</span></td>
            <td>{{tAdnYMoney.aliPayCntRate}} <span :class="tAdnYMoney.aliPayCntRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.aliPayCntRateStr}}</span> </td>
            <td>{{tAdnYMoney.unPayCntRate}} <span :class="tAdnYMoney.unPayCntRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.unPayCntRateStr}}</span> </td>
            <td>{{tAdnYMoney.cashPayCntRate}} <span :class="tAdnYMoney.cashPayCntRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.cashPayCntRateStr}}</span> </td>
            <td>{{tAdnYMoney.otherPayCntRate}} <span :class="tAdnYMoney.otherPayCntRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.otherPayCntRateStr}}</span> </td>
            <td>{{tAdnYMoney.couPayCntRate}} <span :class="tAdnYMoney.couPayCntRateStr=='↑'?'downGreen':'upRed'">{{tAdnYMoney.couPayCntRateStr}}</span> </td>
          </tr>
        </tbody>
      </table>
      <table v-if="isOld"
             class="table_view">
        <thead>
          <tr>
            <td style="background: #f4f2fc"></td>
            <td style="width:45%">入场流量</td>
            <td style="width: 5%"></td>
            <td style="width: 45%">出场流量</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>较昨日同时刻</td>
            <td>{{inOrOutCnt.InParkCntRate}} <span :class="inOrOutCnt.InParkCntRateStr=='↑'?'downGreen':'upRed'">{{inOrOutCnt.InParkCntRateStr}}</span></td>
            <td></td>
            <td>{{inOrOutCnt.OutParkCnt}} <span :class="inOrOutCnt.OutParkCntStr=='↑'?'downGreen':'upRed'">{{inOrOutCnt.OutParkCntStr}}</span></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// 引入 ECharts 主模块
import * as park from '../../api/park'
import { statistics as api } from '../../api/statistics'
import $ from 'jquery'
import * as echarts from 'echarts'
export default {
  data () {
    return {
      apo_data_list: [],
      his_data_list: [],
      initTodayInParkData: {
        fTempNum: 0,
        fCardNum: 0,
        fPoliceNum: 0,
        fFreeNum: 0
      },
      initTodayOutParkData: {
        fTempNum: 0,
        fCardNum: 0,
        fPoliceNum: 0,
        fFreeNum: 0
      },
      inOrOutCnt: {
        InParkCntRate: '',
        InParkCntRateStr: '',
        OutParkCnt: '',
        OutParkCntStr: ''
      },
      parkPaydata: [
        { value: 0, name: '支付金额', itemStyle: { normal: { color: '#E4933F' } } },
        { value: 0, name: '优惠金额', itemStyle: { normal: { color: '#E94151' } } },
        { value: 0, name: '支付笔数', itemStyle: { normal: { color: '#7F3FE4' } } },
        { value: 0, name: '优惠笔数', itemStyle: { normal: { color: '#E43E96' } } }
      ],
      parkPayList: [],
      tAdnYMoney: {
        weChatPayRate: '',
        weChatPayRateStr: '',
        aliPayRate: '',
        aliPayRateStr: '',
        unPayRate: '',
        unPayRateStr: '',
        cashPayRate: '',
        cashPayRateStr: '',
        otherPaytRate: '',
        otherPaytRateStr: '',
        couPayRate: '',
        couPayRateStr: '',
        weChatPayCntRate: '',
        weChatPayCntRateStr: '',
        aliPayCntRate: '',
        aliPayCntRateStr: '',
        unPayCntRate: '',
        unPayCntRateStr: '',
        cashPayCntRate: '',
        cashPayCntRateStr: '',
        otherPayCntRate: '',
        otherPayCntRateStr: '',
        couPayCntRate: '',
        couPayCntRateStr: ''
      },
      fParkCount: 0,
      fParkRate: 0,
      fOutParkCnt: 0,
      fInParkCnt: 0,
      fCalcAmt: 0,
      fPayAmount: 0,
      fPayCnt: 0,
      fDedAmt: 0,
      fCouPayCnt: 0,
      selfCustID: '0',
      selParkID: '0',
      cust_list: [],
      park_list: [],
      isOld: false,
      search_date: ''
    }
  },
  methods: {
    loadPark (fCustID, flag) {
      this.park_list = []
      this.selParkID = ''
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
            if (flag === '1') {
              if (this.park_list && this.park_list.length > 0) {
                this.selParkID = this.park_list[0].fParkID
              }
            }
            this.parkChange()
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    parkChange () {
      this.hadnleSwitch(this.isOld)
      this.loadParkPay()
      this.loadParkInOrOutCnt()
      this.getDayParkRate()
      this.getParkPayStatis()
      this.getParkPayList()
      this.getInOrOutCnt()
      this.getVehicleByID()
      this.getInCardType()
      this.getOutCardType()
    },
    // loadPark () {
    //   api.getParkList().then(res => {
    //     if (res && res.data) {
    //       var data = res.data
    //       if (data.IsOk) {
    //         this.park_list = data.Data
    //         for (let i = 0; i < this.park_list.length; i++) {
    //           var fCustID = this.park_list[i].fCustID
    //           var fParkID = this.park_list[i].fParkID
    //           this.park_list[i].unionKey = fCustID + '_' + fParkID + '_' + this.park_list[i].fCustNo
    //         }
    //       } else {
    //         this.$message.error('提示：加载场库列表失败')
    //       }
    //     }
    //   })
    // },
    loadParkPay () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getParkTodayStat(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.fCalcAmt = data.Data.fCalcAmt
            this.fPayAmount = data.Data.fPayAmount
            this.parkPaydata[0].value = this.fPayAmount
            this.fPayCnt = data.Data.fPayCnt
            this.parkPaydata[2].value = this.fPayCnt
            this.fDedAmt = data.Data.fDedAmt
            this.parkPaydata[1].value = this.fDedAmt
            this.fCouPayCnt = data.Data.fCouPayCnt
            this.parkPaydata[3].value = this.fCouPayCnt
            setTimeout(() => { this.initTodayMoney() }, 0)
          } else {
            this.$message.error('提示：加载支付统计失败')
          }
        }
      })
    },
    loadParkInOrOutCnt () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getInParkOrOutParkCnt(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.fOutParkCnt = data.Data.OutParkCnt
            this.fInParkCnt = data.Data.InParkCnt
          } else {
            this.$message.error('提示：加载今日流量失败')
          }
        }
      })
    },
    getDayParkRate () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getDayParkRate(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.fParkCount = data.Data.fParkCount
            this.fParkRate = data.Data.fParkRate
          } else {
            this.$message.error('提示：加载今日饱和度失败')
          }
        }
      })
    },
    getParkPayStatis () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getParkPayStatis(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.tAdnYMoney = {}
            Object.assign(this.tAdnYMoney, data.Data)
          } else {
            this.$message.error('提示：加载收入趋势失败')
          }
        }
      })
    },
    getParkPayList () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getParkPayList(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.parkPayList = []
            Object.assign(this.parkPayList, data.Data)
          } else {
            this.$message.error('提示：加载今日收入失败')
          }
        }
      })
    },
    getInOrOutCnt () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getInOrOutCnt(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.inOrOutCnt = {}
            Object.assign(this.inOrOutCnt, data.Data)
          } else {
            this.$message.error('提示：加载今日流量失败')
          }
        }
      })
    },
    getInCardType () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getInCardType(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.initTodayInParkData = {}
            Object.assign(this.initTodayInParkData, data.Data)
          } else {
            this.$message.error('提示：加载今日收入失败')
          }
        }
      })
    },
    getOutCardType () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getOutCardType(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.initTodayOutParkData = {}
            Object.assign(this.initTodayOutParkData, data.Data)
          } else {
            this.$message.error('提示：加载今日收入失败')
          }
        }
      })
    },
    getVehicleByID () {
      var parm = {}
      parm.fCustID = this.selfCustID
      parm.fParkID = this.selParkID
      api.getVehicleByID(parm).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.apo_data_list = []
            this.his_data_list = []
            Object.assign(this.apo_data_list, data.Data.apo_data_list)
            Object.assign(this.his_data_list, data.Data.his_data_list)
          } else {
            this.$message.error('提示：加载今日流量失败')
          }
        }
      })
    },
    hadnleSwitch (isOld) {
      this.isOld = isOld
      if (this.isOld) {
        // this.initFlow()
        $('#todayMoney').hide()
        $('#todayFlow').show()
        setTimeout(() => { this.initFlow() }, 0)
      } else {
        // this.initTodayMoney()
        $('#todayMoney').show()
        $('#todayFlow').hide()
        setTimeout(() => { this.initTodayMoney() }, 0)
      }
    },
    initFlow () {
      this.initTodayFlow()
      this.initTodayInPark()
      this.initTodayOutPark()
    },
    initTodayMoney () {
      var chartDom = document.getElementById('payChart')
      if (!chartDom) {
        return
      }
      var myChart = echarts.init(chartDom)
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            if (params.dataIndex === 0 || params.dataIndex === 1) {
              return params.name + ' ：' + params.value + '元'
            } else {
              return params.name + ' ：' + params.value + '笔'
            }
          }
        },
        xAxis: {
          type: 'category',
          data: ['支付金额', '优惠金额', '支付笔数', '优惠笔数'],
          name: '停车场'
        },
        yAxis: {
          type: 'value',
          name: '金额',
          axisLine: {
            show: true
          },
          boundaryGap: false,
          splitLine: {
            show: false
          }
        },
        // series: data
        series: [
          {
            itemStyle: {
              normal: {
                barBorderRadius: [50, 50, 0, 0]
              }
            },
            data: this.parkPaydata,
            type: 'bar',
            barWidth: '20%'
          }
        ]
      }
      myChart.setOption(option)
    },
    initTodayFlow () {
      var chartDom1 = document.getElementById('flowChart')
      if (!chartDom1) {
        return
      }
      var outData = this.his_data_list
      var inData = this.apo_data_list
      // var fInParkCnt = this.fInParkCnt
      // var fOutParkCnt = this.fOutParkCnt
      var myChart1 = echarts.init(chartDom1)
      var option = {
        // title: {
        //   top: 5,
        //   // text: '今日流量 入场车辆：730 离场车辆：341',
        //    text: '{a|' + '今日流量' + '}{b|' + '入场车辆：' + fInParkCnt + '} {b|' + '离场车辆：' + fOutParkCnt + '}',
        //   textStyle: {
        //     rich: {
        //       a: {
        //         fontSize: 16,
        //         align: 'left',
        //         padding: [0, 0, 0, 10]
        //       },
        //       b: {
        //         fontSize: 16,
        //         align: 'left',
        //         padding: [0, 0, 0, 10]
        //       }
        //     }
        //   },
        //   align: 'left'
        // },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['Email', 'Union Ads'],
          show: false
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // nameLocation: 'middle',
          // nameGap: 20,
          name: '时间',
          splitLine: {
            show: false
          },
          boundaryGap: false,
          data: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
        },
        yAxis: {
          type: 'value',
          name: '辆',
          axisLine: {
            show: true
          },
          // axisLine: { onZero: true },
          // axisLabel: {
          //   formatter: '{value} km'
          // },
          boundaryGap: false,
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: '入场车辆',
            type: 'line',
            stack: 'Total',
            data: inData
          },
          {
            name: '离场车辆',
            type: 'line',
            stack: 'Total',
            data: outData
          }
        ]
      }
      myChart1.setOption(option)
    },
    initTodayInPark () {
      var tmpData = this.initTodayInParkData
      var data = [
        { value: tmpData.fTempNum, name: '临时车', itemStyle: { normal: { color: '#ff4651' } } },
        { value: tmpData.fCardNum, name: '月卡车', itemStyle: { normal: { color: '#4292ff' } } },
        { value: tmpData.fFreeNum, name: '免费车', itemStyle: { normal: { color: '#fb8a11' } } },
        { value: tmpData.fPoliceNum, name: '特殊车辆', itemStyle: { normal: { color: '#fb1190' } } }
      ]
      var tmpTotal = tmpData.fTempNum + tmpData.fCardNum + tmpData.fFreeNum + tmpData.fPoliceNum
      var chartDom = document.getElementById('inParkChart')
      if (!chartDom) {
        return
      }
      var myChart = echarts.init(chartDom)
      var option = {
        title: {
          text: '入场车辆',
          align: 'left',
          left: 20,
          top: 20
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        legend: {
          data: [
            '临时车',
            '月卡车',
            '免费车',
            '特殊车辆'
          ],
          orient: 'vertical',
          top: 50,
          left: 20,
          align: 'left',
          formatter: function (name) {
            var total = 0
            var target
            for (var i = 0, l = data.length; i < l; i++) {
              total += data[i].value
              if (data[i].name === name) {
                target = data[i].value
              }
            }
            if (total > 0) {
              var arr = [
                '{a|' + name + '\r\n}{b|' + ((target / total) * 100).toFixed(2) + '%}'

              ]
              return arr.join('\n')
            } else {
              var arrEmpty = [
                '{a|' + name + '\r\n}{b|' + (0).toFixed(2) + '%}'

              ]
              return arrEmpty.join('\n')
            }
          },
          textStyle: {
            rich: {
              a: {
                fontSize: 16,
                align: 'left',
                padding: [0, 0, 0, 10]
              },
              b: {
                fontSize: 16,
                align: 'left',
                padding: [0, 0, 0, 10]
              }
            }
          }
        },
        series: [
          {
            name: '入场车辆',
            type: 'pie',
            radius: ['45%', '60%'],
            itemStyle: {
              // borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 5
            },
            label: {
              normal: {
                show: true,
                position: 'center',
                color: '#4c4a4a',
                formatter: '{label|' + ' 合计}' + '\n\r' + '{total|' + tmpTotal + '}',
                rich: {
                  total: {
                    fontSize: 35,
                    fontFamily: '微软雅黑',
                    color: '#454c5c'
                  },
                  label: {
                    fontSize: 15,
                    fontFamily: '微软雅黑',
                    color: '#454c5c'
                  },
                  active: {
                    fontFamily: '微软雅黑',
                    fontSize: 16,
                    color: '#6c7a89',
                    lineHeight: 30
                  }
                },
                emphasis: {
                  show: true
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              emphasis: {
                show: true
              },
              tooltip: {
                show: false
              }
            },
            data: data
          }
        ]
      }
      option && myChart.setOption(option)
    },
    initTodayOutPark () {
      var tmpData = this.initTodayOutParkData
      var data = [
        { value: tmpData.fTempNum, name: '临时车', itemStyle: { normal: { color: '#ff4651' } } },
        { value: tmpData.fCardNum, name: '月卡车', itemStyle: { normal: { color: '#4292ff' } } },
        { value: tmpData.fFreeNum, name: '免费车', itemStyle: { normal: { color: '#fb8a11' } } },
        { value: tmpData.fPoliceNum, name: '特殊车辆', itemStyle: { normal: { color: '#fb1190' } } }
      ]
      var tmpTotal = tmpData.fTempNum + tmpData.fCardNum + tmpData.fFreeNum + tmpData.fPoliceNum
      var chartDom = document.getElementById('outParkChart')
      if (!chartDom) {
        return
      }
      var myChart = echarts.init(chartDom)
      var option = {
        title: {
          text: '出场车辆',
          align: 'left',
          left: 20,
          top: 20
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        legend: {
          data: [
            '临时车',
            '月卡车',
            '免费车',
            '特殊车辆'
          ],
          orient: 'vertical',
          top: 50,
          left: 20,
          align: 'left',
          formatter: function (name) {
            var total = 0
            var target
            for (var i = 0, l = data.length; i < l; i++) {
              total += data[i].value
              if (data[i].name === name) {
                target = data[i].value
              }
            }
            if (total > 0) {
              var arr = [
                '{a|' + name + '\r\n}{b|' + ((target / total) * 100).toFixed(2) + '%}'

              ]
              return arr.join('\n')
            } else {
              var arrEmpty = [
                '{a|' + name + '\r\n}{b|' + (0).toFixed(2) + '%}'

              ]
              return arrEmpty.join('\n')
            }
          },
          textStyle: {
            rich: {
              a: {
                fontSize: 16,
                align: 'left',
                padding: [0, 0, 0, 10]
              },
              b: {
                fontSize: 16,
                align: 'left',
                padding: [0, 0, 0, 10]
              }
            }
          }
        },
        series: [
          {
            name: '出场车辆',
            type: 'pie',
            radius: ['45%', '60%'],
            itemStyle: {
              // borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 5
            },
            label: {
              normal: {
                show: true,
                position: 'center',
                color: '#4c4a4a',
                formatter: '{label|' + ' 合计}' + '\n\r' + '{total|' + tmpTotal + '}',
                rich: {
                  total: {
                    fontSize: 35,
                    fontFamily: '微软雅黑',
                    color: '#454c5c'
                  },
                  label: {
                    fontSize: 15,
                    fontFamily: '微软雅黑',
                    color: '#454c5c'
                  },
                  active: {
                    fontFamily: '微软雅黑',
                    fontSize: 16,
                    color: '#6c7a89',
                    lineHeight: 30
                  }
                },
                emphasis: {
                  show: true
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              emphasis: {
                show: true
              },
              tooltip: {
                show: false
              }
            },
            data: data
          }
        ]
      }
      option && myChart.setOption(option)
    }
  },
  mounted () {
    this.selfCustID = this.$route.query.fCustID
    this.loadPark(this.selfCustID, '0')
    this.selParkID = this.$route.query.fParkID
    park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.cust_list = data.Data
        } else {
          this.$message.error('提示：加载客户列表失败')
        }
      }
    })
  }
}
</script>

<style  scoped>
.parkTitle {
  padding-right: 15px;
}
.bottomFontColor {
  color: #151515;
  opacity: 0.8;
}
.upRed {
  color: #e7404a;
}
.downGreen {
  color: #5ce740;
}
.outside {
  background: #f4f2fc;
  margin-top: 10px;
  /*padding: 10px;*/
  border-radius: 5px;
  font-size: 12px;
}
.outsideTitle {
  text-align: center;
  background: #f4f2fc;
  float: left;
  width: 50%;
  padding-top: 10px;
  padding-bottom: 10px;
}
.outsideSpan {
  font-size: 20px;
  font-family: Arial;
  font-weight: bold;
  font-style: italic;
  color: #151515;
  opacity: 0.8;
}
.outsideTitle2 {
  text-align: center;
  background: #f4f2fc;
  float: left;
  width: 25%;
  padding-top: 10px;
  padding-bottom: 10px;
}
.outsideTitle3 {
  /*padding:10px;*/
  background: #efedf8;
  clear: both;
  padding-top: 10px;
  padding-bottom: 5px;
}
.insideTitle {
  height: 40px;
  text-align: center;
  font-size: 16px;
  float: left;
  width: 10%;
  /*background-color: green;*/
}
.insideLastTitle {
  padding-left: 20px;
  height: 40px;
  text-align: center;
  font-size: 16px;
  float: left;
  width: 10%;
  /*background-color: green;*/
}
.insideValue {
  height: 40px;
  text-align: center;
  font-size: 16px;
  float: left;
  width: 10%;
  font-weight: bold;
  color: #e7404a;
  /*background-color: green;*/
}
.insideValueLast {
  padding-left: 20px;
  height: 40px;
  text-align: center;
  font-size: 16px;
  float: left;
  width: 10%;
  font-weight: bold;
  color: #e7404a;
  /*background-color: green;*/
}
.insideValueVerLine {
  border-right: 1px solid rgba(25, 17, 15, 0.15);
  float: left;
  width: 1%;
  height: 40px;
}
.insideBothClear {
  clear: both;
}
h3.tip {
  margin: 0px;
}
.el-table th {
  background-color: #f4f2fc !important;
}
.tbHead {
  background-color: #f4f2fc;
}
.home_main {
  padding: 10px;
  background-color: #dddbe8;
  /*position: relative;*/
  /*left: -20px;*/
  /*top: -20px;*/
  /*background-color: #0a67fb;*/
}
.row_msg_tip {
  padding: 15px;
  text-align: left;
  background: #efedf8;
  border-radius: 5px;
  color: #5a595d;
}
.row_icon_tip {
  background: #efedf8;
  margin-top: 20px;
  padding: 10px;
  border-radius: 5px;
}
.icon_theme_one,
.icon_theme_two {
  padding: 10px 25px;
  margin: 10px;
  background: #eae8f2;
  border-radius: 6px;
  display: inline-block;
  cursor: pointer;
}
.icon_theme_active {
  background: #3d84e1;
  color: #ffffff;
}
.row_card {
  display: flex;
  align-items: center;
  padding-bottom: 40px;
}

.row_card .card_item {
  width: calc((100% - 100px) / 5);
  height: 160px;
  border-radius: 5px;
  color: #ffffff;
}
.card_item_one {
  background-image: linear-gradient(to right, #43a8ec, #3d85e1);
  box-shadow: 15px 15px #c5d4f3;
}
.card_item_two {
  background-image: linear-gradient(to right, #3dc2d9, #38a0ce);
  box-shadow: 15px 15px #c1d9ee;
}
.card_item_three {
  background-image: linear-gradient(to right, #51cb7a, #4cc187);
  box-shadow: 15px 15px #c5d4f3;
}
.card_item_four {
  background-image: linear-gradient(to right, #ef8363, #e6945f);
  box-shadow: 15px 15px #c5d4f3;
}
.card_item_five {
  background-image: linear-gradient(to right, #42a9ec, #3d85e1);
  box-shadow: 15px 15px #c5d4f3;
}
.left_margin_left_10 {
  margin-left: 10px;
}
.left_margin_left_20 {
  margin-left: 20px;
}
.left_margin_right_10 {
  margin-right: 10px;
}
.card_item img {
  width: 100px;
  height: 100px;
}
.card_item .card_msg {
  margin-top: 20px;
  margin-bottom: 0px;
  font-size: 20px;
}
.card_item .card_number {
  margin-top: 10px;
  margin-bottom: 10px;
}
.card_item .card_number > span {
  font-size: 14px;
}
.card_item .card_line {
  border: 0.5px solid rgba(252, 249, 249, 0.2);
  margin-right: 20px;
}
.row_table {
  background: #f4f2fc;
  border-radius: 5px;
  margin-top: 10px;
}
.col_backcolor {
  background: #f4f2fc;
  border-radius: 5px;
  height: 300px;
}
.col_backcolorBlank {
  background: #f4f2fc;
  padding: 5px;
  height: 300px;
}
.chartCol_backcolor {
  background: white;
  border-radius: 5px;
  height: 300px;
}
.row_table .table_form_search {
  background: #f4f2fc;
}
.row_table .table_form_search > span {
  display: inline-block;
  padding: 20px 30px;
}
/*.row_table .table_form_search > .search {*/
/*float: right;*/
/*margin: 15px 10px;*/
/*width: 300px;*/
/*height: 30px;*/
/*border: 1px solid #dedce5;*/
/*outline: none;*/
/*border-radius: 15px;*/
/*line-height: 30px;*/
/*padding-left: 30px;*/
/*background: url("../../assets/images/search.png") no-repeat 8px 10px;*/
/*}*/
.table_view {
  width: 100%;
  padding: 10px;
}
/* .table_view thead > tr {
    display: flex;
    justify-content: center;
    align-items: center;
  } */
.table_view thead > tr > td {
  padding: 10px 0px;
  text-align: center;
  width: calc(100% / 10);
}
.table_view thead > tr > td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.table_view thead > tr > td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.table_view thead > tr > td:nth-child(2n-1) {
  background: #dde5f6;
}
.table_view thead > tr > td:nth-child(2n) {
  background: #e6e9f7;
}
.table_view tbody > tr {
  background: #f5f4fb;
  margin: 10px 0px;
}
.table_view tbody > tr > td {
  text-align: center;
  padding: 10px 0px;
}
.color1 {
  color: #72adeb;
}
.color2 {
  color: #6fc1de;
}
.color3 {
  color: #7bd09d;
}
.color4 {
  color: #87a5ee;
}
.color5 {
  color: #79bde1;
}
.block_search {
  float: right;
  margin-top: 10px;
}
</style >

<style>
/*#IndexNewDiv .row_table .el-table  thead > tr > th {*/
/*background: #f4f2fc;*/
/*border-radius: 5px;*/
/*}*/
#detailDiv .row_table .el-table thead > tr > th {
  padding: 10px 0px !important;
  text-align: center !important;
  width: calc(100% / 10) !important;
}
/*#IndexNewDiv .row_table .el-table  thead > tr > td:first-child {*/
/*padding: 10px 0px !important;*/
/*text-align: left !important;*/
/*width: calc(100% / 10) !important;*/
/*}*/
/*#IndexNewDiv .row_table .el-table  thead > tr > th:first-child {*/
/*border-top-left-radius: 10px !important;*/
/*border-bottom-left-radius: 10px !important;*/
/*}*/
/*#IndexNewDiv .row_table .el-table  thead > tr > th:last-child {*/
/*border-top-right-radius: 10px !important;*/
/*border-bottom-right-radius: 10px !important;*/
/*}*/
#detailDiv .row_table .el-table thead > tr > th:nth-child(2n-1) {
  background: #dde5f6 !important;
}
#detailDiv .row_table .el-table thead > tr > th:nth-child(2n) {
  background: #e6e9f7 !important;
}
#detailDiv .el-table,
.el-table__expanded-cell {
  background-color: #f4f2fc;
}
#detailDiv .row_table .el-table td:first-child {
  background: #f4f2fc !important;
  padding-bottom: 10px !important;
  padding-bottom: 10px !important;
  text-align: left !important;
  /*border-radius: 5px;*/
}
#detailDiv .row_table .el-table td:nth-child(2) {
  color: #72adeb;
}
#detailDiv .row_table .el-table td:nth-child(3) {
  color: #6fc1de;
}
#detailDiv .row_table .el-table td:nth-child(4) {
  color: #7bd09d;
}
#detailDiv .row_table .el-table td:nth-child(5) {
  color: #87a5ee;
}
#detailDiv .row_table .el-table td:nth-child(6) {
  color: #79bde1;
}
/*#IndexNewDiv .row_table .el-table td:not(first-child) {*/
/*background: #f4f2fc !important;*/
/*padding-bottom: 10px  !important;*/
/*padding-bottom: 10px !important;*/
/*text-align: right !important;*/
/*!*border-radius: 5px;*!*/
/*}*/
#detailDiv .row_table .el-table td {
  background: #f4f2fc !important;
  padding-bottom: 10px !important;
  padding-bottom: 10px !important;
  text-align: center !important;
  /*border-radius: 5px;*/
}
#detailDiv .row_table .table_form_search > .vuesearch {
  float: right;
  margin: 15px 10px;
  width: 300px;
  height: 30px !important;
  border: 1px solid #dedce5;
  outline: none;
  border-radius: 15px;
  line-height: 30px;
  padding-left: 30px;
}
#detailDiv .row_table .table_form_search .el-input--prefix .el-input__inner {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
#detailDiv .row_table .table_form_search .el-input--prefix .el-input__inner {
  font-family: 微软雅黑;
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  width: 300px;
  border: 0px solid #dedce5;
  background-color: #f4f2fc;
  /*border-radius: 15px;*/
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/home/detail.vue